<template>
  <div class="app-content-wrapper sms-page">
    <div class="top-wrapper margin-bottom-20">
      <img
        class="img-top-wrapper"
        src="@/assets/images/security/img-sms.png"
      />
      <div class="margin-left-20">
        <p class="top-title">{{ $t("message.user.smsNoticeTitle") }}</p>
        <p class="top-desc">{{ $t("message.user.smsNoticeDesc") }}</p>
      </div>
    </div>
    <div v-loading="dataLoading" class="content-box margin-bottom-20">
      <div class="content-top-box">
        <div>
          <p class="content-title margin-bottom-8">{{ $t('message.user.smsNoticeTitle') }}</p>
          <p class="content-desc">{{ $t('message.user.smsNoticeSwitch') }}</p>
        </div>
        <el-switch v-permission="'account:security:sms:switch'" v-model="checked" @change="handleSwitchChange"></el-switch>
      </div>
      <div v-show="checked" class="content-info-box">
        <div class="table-info-box">
          <el-table
            ref="table"
            :data="tableData"
            :height="300"
            @selection-change="handleSelectionChange">
            <el-table-column
              width="55"
              class-name="checkbox">
              <template #header>
                <el-checkbox :indeterminate="indeterminate" v-model="checkedAll" @change="handleAllChecked"></el-checkbox>
              </template>
              <template slot-scope="{ row }">
                <el-checkbox v-model="row.canNotice" @change="handleItemChecked(row, $event)"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column
              prop="operatorName"
              :label="$t('message.permission.name')"
              width="200">
            </el-table-column>
            <el-table-column
              prop="operatorPhoneNumber"
              :label="$t('message.user.phoneNumber')"
              width="150">
              <template slot-scope="{ row }">
                {{ `${row.areaCode || ''} ${row.operatorPhoneNumber}` }}
              </template>
            </el-table-column>
            <template #empty><span></span></template>
          </el-table>
        </div>
        <el-button v-permission="'account:security:sms:submit'" class="margin-top-20" type="primary" @click="handleSave">{{$t('message.common.submit')}}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { ShowSuccessMessage, ShowWarningMessage } from '@/components/modal/tips/message-tips';
import { arr2obj } from '@/utils/tools/utils';
import {
  queryMsgOperatorList, updateMsgOperatorList,
  updateMessageNotice, queryMessageNotice,
} from '@/views/account/security/api/sms';

export default {
  components: {
  },
  data() {
    return {
      dataLoading: false,
      checked: true,
      showSubmitBtn: false,
      checkedAll: false,
      tableData: [],
      selectedList: [],
      indeterminate: false,
    };
  },
  mounted() {
    this.initMethod();
  },
  beforeDestroy() {
    this.timer && clearTimeout(this.timer);
  },
  methods: {
    async initMethod() {
      this.dataLoading = true;
      try {
        // 获取当前配置和选中项
        this.checked = !!(+(await queryMessageNotice()));
        const res = await queryMsgOperatorList();
        this.tableData = res || [];

        this.tableData.forEach(item => {
          if (item.canNotice) {
            this.selectedList.push(item.operatorId);
          }
        });
        this.checkedAll = this.tableData.length === this.selectedList.length;
        if (!this.checkedAll && this.selectedList.length > 0) {
          this.indeterminate = true;
        }
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
    async handleSwitchChange() {
      try {
        await updateMessageNotice({ status: this.checked ? '1' : '0' });
        ShowSuccessMessage(this.$t('message.operateSuccessfulTip'));
      } catch (err) {
        this.checked = !this.checked; // 操作失败，切回原状态
      }
    },
    handleSelectionChange(values) {
      const checks = arr2obj(values, { key: 'operatorId' });
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].canNotice = !!checks[this.tableData[i].operatorId];
      }
    },
    async handleSave() {
      this.dataLoading = true;
      try {
        await updateMsgOperatorList(this.tableData.map(item => ({
          userId: item.userId,
          operatorId: item.operatorId,
          canNotice: this.selectedList.indexOf(item.operatorId) > -1,
        })));
        ShowSuccessMessage(this.$t('message.operateSuccessfulTip'));
      } catch (err) {
        //
      }
      this.dataLoading = false;
    },
    handleItemChecked(row, value) {
      console.log(row, value, 'row, value');
      if (value) {
        this.selectedList.push(row.operatorId);
      } else {
        this.selectedList = this.selectedList.filter(item => item !== row.operatorId);
      }
      this.checkedAll = this.tableData.length === this.selectedList.length;
      if (!this.checkedAll && this.selectedList.length > 0) {
        this.indeterminate = true;
      } else {
        this.indeterminate = false;
      }
    },
    handleAllChecked(value) {
      this.selectedList = [];
      for (let i = 0; i < this.tableData.length; i++) {
        this.tableData[i].canNotice = value;
        if (value) {
          this.selectedList.push(this.tableData[i].operatorId);
        }
      }
      this.indeterminate = false;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";

.sms-page {
  .top-wrapper {
    display: flex;
    align-items: center;
    margin-top: 36px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(0, 32, 63, 0.08);

    .img-top-wrapper {
      width: 110px;
      height: 102px;
    }

    .top-title {
      font-size: 16px;
      font-family: PingFangTC-Semibold, PingFangTC;
      font-weight: 600;
      color: $color-text-primary;
      line-height: 28px;
    }

    .top-desc {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: $color-text-primary;
      line-height: 21px;
    }
  }

  .content-box {
    background: #F1F5F7;
    border-radius: 2px;

    .content-desc {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 500;
      color: $color-text-primary;
      line-height: 26px;
    }

    .content-title {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: bold;
      color: $color-text-primary;
      line-height: 25px;
    }

    .content-top-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 100px;
      padding-left: 25px;
      padding-right: 30px;

      ::v-deep .el-switch {
        height: 34px;
      }

      ::v-deep .el-switch__core {
        width: 70px !important;
        height: 34px;
        border-radius: 17px;

        &:after {
          width: 30px;
          height: 30px;
        }
      }

      ::v-deep .el-switch.is-checked .el-switch__core::after {
        margin-left: -30px;
      }
    }

    .content-info-box {
      border-top: 1px solid rgba(0,32,63,0.15);
      padding-top: 20px;
      padding-bottom: 25px;
      padding-left: 30px;

      .table-info-box {
        width: 410px;
        height: 310px;
        background-color: white;
        overflow-y: scroll;

        ::v-deep .el-table__header-wrapper thead tr .checkbox .cell {
          padding-left: 16px;
        }

        ::v-deep .el-table__header-wrapper thead tr .el-table-column--selection .cell {
          padding-left: 16px;
        }

        ::v-deep .el-table__header-wrapper thead tr .el-table__cell .cell {
          color: $color-text-primary;
          font-family: Avenir-Heavy, Avenir;
          font-weight: 800;
        }

        ::v-deep .el-table__body tbody tr .checkbox .cell {
          padding-left: 16px;
        }

        ::v-deep .el-table__body tbody tr .el-table__cell .cell {
          color: $color-text-primary;
          font-weight: 500;
        }

        ::v-deep .el-table__body tbody tr td {
          border-bottom: none;
        }
        ::v-deep .el-table::before {
          background-color: transparent;
        }
      }
    }
  }
}
</style>
